import { Component } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-iqac',
  templateUrl: './iqac.component.html',
  styleUrls: ['./iqac.component.scss'],
})
export class IqacComponent {
  isBestPracticesPage = false;

  constructor(private router: Router) {
    // Listen for route changes
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        // Check if route includes '/iqac/best-prac'
        this.isBestPracticesPage = event.urlAfterRedirects.startsWith('/iqac/best-prac');
      });
  }
}
